import { TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SimpleTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-root': {
        width: '100%',
        height: '2rem',
        minHeight: '2rem',
        backgroundColor: theme.palette.primary[300],
        borderRadius: '8px',
        '&.Mui-focused': {
            backgroundColor: `${theme.palette.secondary.light} !important`
        },
        '&.Mui-disabled': {
            backgroundColor: `${theme.palette.primary[500]} !important`
        },
        '& .MuiInputBase-input': {
            padding: '0 0.8rem !important',
            margin: '0px !important',
            width: '100%',
            height: '100%',
            backgroundColor: theme.palette.primary[300],
            borderRadius: '8px',
            '&.Mui-focused': {
                backgroundColor: `${theme.palette.secondary.light} !important`
            },
            '&.Mui-disabled': {
                backgroundColor: `${theme.palette.primary[500]} !important`
            }
        }
    },
    '& fieldset': {
        border: 'none !important',
        borderRadius: '8px'
    },
    '& :focus-visible, :focus, :active, .MuiInputBase-root .Mui-focused': {
        backgroundColor: `${theme.palette.secondary.light} !important`,
        color: `${theme.palette.secondary.main} !important`,
        '&::placeholder': { color: 'transparent !important' },
        '& svg': {
            color: `${theme.palette.secondary.main} !important`,
            opacity: 0.5
        }
    }
})) as React.ComponentType<TextFieldProps>;
